export const contactsApiServer = 'https://mobile.itfox-web.com'
export const currentUrl = 'https://mobile.itfox-web.com'
export const contactsMetrica = 89721589
export const contactsGA = 'G-N6S1TZBLDD'